import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import { ProfileGate, PROFILES } from "./components/Netflix";
import { Opening } from "./components/Upgrade";
import Home from "./pages/Home";
import Browse from "./pages/Browse";
import Contact from "./pages/Contact";
import NotFound from "./pages/NotFound";
import "./css/Netflix.css";

const PKEY = "nx-profile";
const IKEY = "nx-intro";

const reduced = () =>
  typeof window !== "undefined" && window.matchMedia &&
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;

function Page({ children }) {
  return (
    <motion.div initial={{ opacity: 0, y: 14 }} animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, transition: { duration: 0.15 } }}
      transition={{ duration: 0.4, ease: [0.2, 0.7, 0.2, 1] }}>
      {children}
    </motion.div>
  );
}

function Shell({ profile, onPick, onSwitch }) {
  const location = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, left: 0, behavior: "instant" }); }, [location.pathname]);

  return (
    <>
      <Navbar profile={profile} onPick={onPick} onSwitch={onSwitch} />
      <AnimatePresence mode="wait">
        <Routes location={location} key={location.pathname}>
          <Route path="/" element={<Page><Home profile={profile} /></Page>} />
          <Route path="/projects" element={<Page><Browse /></Page>} />
          <Route path="/contact" element={<Page><Contact /></Page>} />
          <Route path="*" element={<Page><NotFound /></Page>} />
        </Routes>
      </AnimatePresence>
      <Footer onSwitch={onSwitch} hideCta={location.pathname === "/"} />
    </>
  );
}

function App() {
  const [intro, setIntro] = useState(() => {
    try { return !sessionStorage.getItem(IKEY) && !reduced(); } catch { return false; }
  });
  const [profile, setProfile] = useState(() => {
    try { return PROFILES.find(p => p.id === sessionStorage.getItem(PKEY)) || null; }
    catch { return null; }
  });

  const finishIntro = () => {
    try { sessionStorage.setItem(IKEY, "1"); } catch {}
    setIntro(false);
  };
  const pick = p => {
    setProfile(p);
    try { sessionStorage.setItem(PKEY, p.id); } catch {}
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  };
  const reset = () => {
    setProfile(null);
    try { sessionStorage.removeItem(PKEY); } catch {}
  };

  if (intro) return <Opening onDone={finishIntro} />;
  if (!profile) return <ProfileGate onPick={pick} />;

  return (
    <Router>
      <Shell profile={profile} onPick={pick} onSwitch={reset} />
    </Router>
  );
}

export default App;
